import { Popover } from "antd";
import React, { useEffect, useContext } from "react";
import { ICON_SIZE } from "../../config/layoutConfig";
import InfoContext, { AppContext } from "../../context";
import VillagePanorama from "../Panorama/VillagePanorama";
import VillageOccupancy from "./VillageOccupancy";
import ReactDOM from "react-dom";
import VillageIndicators from "./VillageIndicators";

/* next line is only for deployment, it won't work locally since there's no div with such an id */

function Village({ location }) {
  ReactDOM.render(
    <InfoContext>
      {/* <VillageIndicators villageSlug={location.pathname.split("/")[2]} /> */}
      <VillageIndicators
        villageSlug={location.pathname.split("/").slice(-2)[0]}
      />
    </InfoContext>,
    document.getElementById("village-indicators")
  );
  return (
    <InfoContext>
      <div>
        {/* next line is only for development */}
        {/* <VillageIndicators villageSlug={location.pathname.split("/")[2]} /> */}

        {/* <VillageOccupancy location={location} /> */}
        <div class="tosee-title row-title bg-blue section">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h1 class="title">Fotos 360</h1>
              </div>
            </div>
          </div>
        </div>
        <VillagePanorama location={location} />
      </div>
    </InfoContext>
  );
}

export default Village;
